import { useState } from "react";
import { IconChevronDown, IconChevronRight } from "@tabler/icons-react";
import { Button, Td, Text, Tr } from "@/components/ui";
import type { AdminAuditEntry } from "../services/auditoria-service";
import { AccionBadge } from "./AccionBadge";
import { CategoriaBadge } from "./CategoriaBadge";
import { DetallesAmigables } from "./DetallesAmigables";

/**
 * Fila de evento de cambio · expandible para mostrar el JSON del
 * `detallesJson` formateado. El JSON puede ser bastante largo (>2KB) ·
 * por eso lo escondemos por default.
 */
export function CambioRow({ entry }: { entry: AdminAuditEntry }) {
  const [expandida, setExpandida] = useState(false);
  return (
    <>
      <Tr className="align-top">
        <Td>
          <Text size="xs" c="dimmed" className="whitespace-nowrap">
            {new Date(entry.ocurridoAt).toLocaleString()}
          </Text>
        </Td>
        <Td>
          <CategoriaBadge categoria={entry.categoria} />
        </Td>
        <Td>
          <AccionBadge accion={entry.accion} />
        </Td>
        <Td>
          <Text size="sm">{entry.entidadDescripcion}</Text>
          <Text size="xs" c="dimmed" className="font-mono">
            {entry.entidadId.length > 32
              ? entry.entidadId.substring(0, 8) + "…"
              : entry.entidadId}
          </Text>
        </Td>
        <Td>
          {entry.usuarioEmail ? (
            <Text size="xs" className="font-mono">
              {entry.usuarioEmail}
            </Text>
          ) : (
            <Text size="xs" c="dimmed" className="font-mono" title={entry.usuarioId}>
              {entry.usuarioId.slice(0, 8)}…
            </Text>
          )}
        </Td>
        <Td align="right">
          <Button
            variant="subtle"
            size="xs"
            leftSection={expandida ? <IconChevronDown size={12} /> : <IconChevronRight size={12} />}
            onClick={() => setExpandida((v) => !v)}
          >
            {expandida ? "Ocultar" : "Detalles"}
          </Button>
        </Td>
      </Tr>
      {expandida ? (
        <Tr className="bg-muted/40">
          <Td colSpan={6} className="px-4 py-3">
            <DetallesAmigables detallesJson={entry.detallesJson} />
          </Td>
        </Tr>
      ) : null}
    </>
  );
}
